module.exports = __webpack_public_path__ + "as.no2.fd7ef7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/as.no2.jpg
// module id = 0Dey
// module chunks = 0